import React from 'react';

import classes from './Notifications.module.css';

const notifications = (props) => {
    let notification = (<span key='message' className={classes.Message}>{props.message}</span>);
    let styles = [classes.Notifications, classes[props.style]].join(' ');
    if (props.message === '') {
        styles = [styles, classes.close].join(' ');
    } else {
        const close = (<button key='closeButton' className={classes.Button} onClick={props.clicked}><i
            key='close'
            className={["material-icons", classes.closeButton].join(' ')} >close</i></button>);
        styles = [styles, classes.open].join(' ');
        notification = [notification, close];
        window.scrollTo(0, 0);
    }

    return (
        <div className={styles}>
            {notification}
        </div>
    );
}

export default notifications;